<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{city}}{{$route.meta.label}}</h1>
  </template>

  <template #toolbar>
    <span style="font-size:.8em;color:#606266;">预测高度(米)：</span>
    <el-select v-model="query.height" style="width: 100px;" size="small" @change="getData">
      <el-option
        v-for="item in heightOpt"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
    </el-select>
    <span style="font-size:.8em;color:#606266;">预测日期：</span>
    <el-date-picker
      v-model="query.forecastDate"
      type="date"
      size="small"
      value-format="yyyy/MM/dd 00:00:00"
      placeholder="选择日期"
      :editable="false"
      :clearable="false"
      style="width: 140px;"
      @change="getHeightData(query.forecastDate)"
    >
    </el-date-picker>

    <el-button
      :disabled="!heightOpt.length"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="getData"
    >查询</el-button>
  </template>

  <template #body>
    <section class="data-wrapper" ref="contentBody">
      <section class="data-header">
        <div class="charts-legend">
          <div style="margin-bottom: 10px;font-weight: bold;">时间刻度为UTC时间</div>
          <div class="legend">
            <p>
              <span class="legend-color" style="background: rgb(0, 228, 0);"></span>
              <span>优</span>
            </p>
            <p>
              <span class="legend-color" style="background: rgb(255, 255, 0);"></span>
              <span>良</span>
            </p>
            <p>
              <span class="legend-color" style="background: rgb(255, 126, 0);"></span>
              <span>轻度污染</span>
            </p>
            <p>
              <span class="legend-color" style="background: rgb(255, 0, 0);"></span>
              <span>中度污染</span>
            </p>
            <p>
              <span class="legend-color" style="background: rgb(153, 0, 76);"></span>
              <span>重度污染</span>
            </p>
            <p>
              <span class="legend-color" style="background: rgb(126, 0, 35);"></span>
              <span>严重污染</span>
            </p>
          </div>
        </div>
        <section class="weather-doll">
          <div
            v-for="(item, i) in dayData"
            :key="i"
          >
            <div slot="reference">
              <div class="weather-img">
                <img :src="aqiLevelImgPath[item.grade - 1]" class="aqi-level-img" draggable="false" />
              </div>
              <div class="weather-info">
                <p>{{new Date(item.dataTime).format('YYYY-MM-DD')}}</p>
                <p>AQI: {{item.aqi.toFixed(0)}} {{gradeLevel[item.grade]}}</p>
                <p>首要污染物:{{item.primaryPollutant}}</p>
              </div>
            </div>
          </div>
        </section>

        <div class="gif-wrapper">
          <div v-loading="showGifCover" class="gif-img-wrapper">
            <img
              v-if="typeof query.forecastDate === 'string'"
              :src="`/report/forecast/img/${gifPollutantVal}/${query.forecastDate.replace(/(\/|-|\s|00:00:00)/g, '')}.gif`"
              style="max-width:100%;max-height:100%;cursor:zoom-in;"
              @load="showGifCover = false"
              @error="showGifCover = false"
              @click="onGifClick"
            />

            <div style="position:absolute;top:0px;right:20px;cursor:pointer;" @click="onDownloadBtnClick">
              <i class="el-icon-download"></i>
            </div>
          </div>
          <ul class="aqi-pollutant-list">
            <li
              v-for="gifPollutant in gifPollutants"
              :key="gifPollutant.value"
              :class="{
                selected: gifPollutantVal === gifPollutant.value
              }"
              @click="onAQIPollutantClick(gifPollutant)"
            >{{gifPollutant.label}}</li>
          </ul>
        </div>
      </section>

      <section class="chart-wapper">
        <div class="day-chart" v-for="(item, i) in chartData" :key="i">
          <air-quality-prediction-chart
            ref="dayChart"
            :index="i"
            :data="item.data"
            :day="item.dataTime"
            :client-height="clientHeight"
            :client-width="clientWidth"
          />
        </div>
      </section>
    </section>

    <div v-show="showBigGif" class="big-gif-overlay" @click="showBigGif = false">
      <div class="big-gif-wrapper" @click.stop>
        <div v-loading="showGifCover" class="gif-img-wrapper">
          <img
            v-if="typeof query.forecastDate === 'string'"
            :src="`/report/forecast/img/${gifPollutantVal}/${query.forecastDate.replace(/(\/|-|\s|00:00:00)/g, '')}.gif`"
            style="max-width:100%;max-height:100%;"
            @load="showGifCover = false"
            @error="showGifCover = false"
          />

          <div style="position:absolute;top:20px;right:20px;cursor:pointer;" @click="onDownloadBtnClick">
            <i class="el-icon-download"></i>
          </div>
        </div>

        <ul class="aqi-pollutant-list">
          <li
            v-for="gifPollutant in gifPollutants"
            :key="gifPollutant.value"
            :class="{
                selected: gifPollutantVal === gifPollutant.value
              }"
            @click="onAQIPollutantClick(gifPollutant)"
          >{{gifPollutant.label}}</li>
        </ul>
      </div>
    </div>
  </template>
</layout-content>
</template>

<script>
import BaseData from '../../../BaseData'
import LayoutContent from '../../../../components/Layout/Content'
import DataWrapper from '../../../../components/Data/DataWrapper'
import AirQualityPredictionChart from '../../../../components/Data/AirQualityPredictionChart'
import { Promise } from 'q'

const gifPollutants = [{
  value: 'PM2_5_srf',
  label: 'PM₂.₅'
}, {
  value: 'PM10_srf',
  label: 'PM₁₀'
}, {
  value: 'O3_gas_srf',
  label: 'O₃'
}, {
  value: 'NO2_gas_srf',
  label: 'NO₂'
}, {
  value: 'SO2_gas_srf',
  label: 'SO₂'
}, {
  value: 'CO_gas_srf',
  label: 'CO'
}]

export default {
  name: 'AirQualityPrediction',
  routeInfo: {
    label: '空气质量预测'
  },
  extends: BaseData,
  components: {LayoutContent, DataWrapper, AirQualityPredictionChart},
  data () {
    return {
      query: {
      },
      city: '',
      heightOpt: [],
      dayData: [],
      chartData: [],
      clientHeight: 0,
      clientWidth: 0,
      gifPollutantVal: gifPollutants[0].value,
      showGifCover: false,
      showBigGif: false
    }
  },
  computed: {
    aqiLevelImgPath () {
      let basePath = '/static/imgs/aqi'
      let aqiLevelImgPath = []

      for (let i = 1; i <= 6; i++) {
        aqiLevelImgPath.push(`${basePath}/level-${i}.png`)
      }

      return aqiLevelImgPath
    },
    aqiColorMap () {
      return {
        1: 'rgb(0, 228, 0)',
        2: 'rgb(255, 255, 0)',
        3: 'rgb(255, 126, 0)',
        4: 'rgb(255, 0, 0)',
        5: 'rgb(153, 0, 76)',
        6: 'rgb(126, 0, 35)'
      }
    },
    // grade状态码
    gradeLevel () {
      return {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }
    },
    gifPollutants: () => gifPollutants
  },
  methods: {
    getNewDate () {
      this.changeLoadStatus(true)
      this.$api.Forecast.getNewDate().then(data => {
        if (!data) return
        this.defualtQueryData = Object.freeze(data)
        this.query = {
          height: data.height,
          forecastDate: new Date(data.forecastDate).format('YYYY/MM/DD HH:mm:ss')
        }
        this.city = Object.freeze(data.cityName)
        this.getHeightData(data.forecastDate)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getHeightData (forecastDate) {
      this.changeLoadStatus(true)
      this.showGifCover = true
      let query = {
        forecastDate: new Date(forecastDate).format('YYYY/MM/DD HH:mm:ss')
      }
      this.$api.Forecast.getHeightData(query).then(data => {
        if (!data.length) {
          this.heightOpt = Object.freeze([])
          this.query = {
            height: '',
            forecastDate: forecastDate
          }
          this.dayData = Object.freeze([])
          this.chartData = Object.freeze([])
          return
        }

        this.heightOpt = Object.freeze(data)
        this.query.height = data[0]

        this.getData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getData () {
      Promise.all([this.getDayData(), this.getHourData()]).then(() => {
        this.windowResize()
      })
    },
    getDayData () {
      this.changeLoadStatus(true)
      let query = this.query
      this.$api.Forecast.getDayData(query).then(data => {
        this.dayData = Object.freeze(data.map(el => {
          let pollutantData = el.pollutantData.map(item => {
            return {
              ...item,
              rootFactorId: this.replaceFactor(item.rootFactorId)
            }
          })
          return {
            ...el,
            pollutantData: pollutantData,
            primaryPollutant: this.replaceFactor(el.primaryPollutant)
          }
        }))
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getHourData () {
      this.changeLoadStatus(true)
      let query = this.query
      this.$api.Forecast.getHourData(query).then(data => {
        this.formatHourData(data.map(el => {
          let date = new Date(el.dataTime).getTime()

          return {
            ...el,
            aqi: Number.isFinite(el.aqi) ? Math.round(el.aqi) : null,
            dataTime: new Date(date - 3600000).format('YYYY/MM/DD HH:mm:ss')
          }
        }))
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatHourData (data) {
      let {aqiColorMap} = this

      let newData = data.map(el => {
        let aqiData = {
          dataTime: el.dataTime,
          value: Number(el.aqi.toFixed(2)),
          grade: el.grade,
          itemStyle: {
            color: aqiColorMap[el.grade]
          }
        }
        let pm25Data, pm10Data, o3Data, so2Data, no2Data, coData

        el.pollutantData.forEach(item => {
          if (item.rootFactorId === 'PM2.5_24H' || item.rootFactorId === 'PM2.5') {
            pm25Data = {
              dataTime: el.dataTime,
              rootFactorId: this.replaceFactor(item.rootFactorId),
              value: Number(item.value.toFixed(2))
            }
          }

          if (item.rootFactorId === 'PM10_24H' || item.rootFactorId === 'PM10') {
            pm10Data = {
              dataTime: el.dataTime,
              rootFactorId: this.replaceFactor(item.rootFactorId),
              value: Number(item.value.toFixed(2))
            }
          }

          if (item.rootFactorId === 'O3') {
            o3Data = {
              dataTime: el.dataTime,
              rootFactorId: this.replaceFactor(item.rootFactorId),
              value: Number(item.value.toFixed(2))
            }
          }

          if (item.rootFactorId === 'SO2') {
            so2Data = {
              dataTime: el.dataTime,
              rootFactorId: item.rootFactorId,
              value: Number(item.value.toFixed(2))
            }
          }

          if (item.rootFactorId === 'NO2') {
            no2Data = {
              dataTime: el.dataTime,
              rootFactorId: item.rootFactorId,
              value: Number(item.value.toFixed(2))
            }
          }

          if (item.rootFactorId === 'CO') {
            coData = {
              dataTime: el.dataTime,
              rootFactorId: item.rootFactorId,
              value: Number(item.value.toFixed(2))
            }
          }
        })

        return {
          ...el,
          aqiData: aqiData,
          pm10Data: pm10Data,
          pm25Data: pm25Data,
          coData: coData,
          no2Data: no2Data,
          so2Data: so2Data,
          o3Data: o3Data
        }
      })

      let dayMap = newData.reduce((map, el) => {
        let date = new Date(el.dataTime).format('YYYY/MM/DD')
        if (!map[date]) {
          map[date] = {
            dataTime: date,
            data: []
          }
        }

        let pollutantData = el.pollutantData.map(item => {
          return {
            ...item,
            rootFactorId: this.replaceFactor(item.rootFactorId)
          }
        })

        map[date].data.push({
          ...el,
          pollutantData: pollutantData,
          primaryPollutant: this.replaceFactor(el.primaryPollutant)
        })

        return map
      }, {})

      this.chartData = Object.freeze(Object.values(dayMap))

      setTimeout(() => {
        let charts = this.$refs.dayChart
        charts.forEach(el => {
          el.renderChart()
        })
      }, 100)
    },
    replaceFactor (factor) {
      return factor.replace('H8O3', 'O3').replace('PM2.5_24H', 'PM2.5').replace('PM10_24H', 'PM10')
    },
    windowResize () {
      let contentBody = this.$refs.contentBody
      let clientHeight = contentBody.clientHeight
      let clientWidth = contentBody.clientWidth
      this.clientHeight = Object.freeze(clientHeight - 190)
      this.clientWidth = Object.freeze(clientWidth)
    },
    onAQIPollutantClick (gifPollutant) {
      this.gifPollutantVal = gifPollutant.value
      this.showGifCover = true
    },
    onGifClick () {
      this.showBigGif = true
    },
    onDownloadBtnClick () {
      const a = document.createElement('a')
      a.download = `气象预测-${this.query.forecastDate.replace(/(\/|-|\s|00:00:00)/g, '')}.gif`
      a.href = `/report/forecast/img/${this.gifPollutantVal}/${this.query.forecastDate.replace(/(\/|-|\s|00:00:00)/g, '')}.gif`
      a.click()
    }
  },
  created () {
    window.addEventListener('resize', this.windowResize)
    this.getNewDate()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResize)
  }
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 180px auto;
  grid-gap: 10px;
  position: relative;
  overflow: hidden;

  .data-header {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 100%;
    align-items: center;

    .charts-legend {
      text-align: center;
      margin: 3px 0 7px 0;
      user-select: none;

      > .legend {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 5px;

        > p {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0 5px;
          font-size: 10px;

          > .legend-color {
            width: 20px;
            height: 13px;
            margin: 0 5px 0 5px;
          }
        }
      }
    }

    .weather-doll {
      width: 100%;
      height: 100%;
      display: grid;
      grid-template-columns: max-content max-content max-content;
      grid-template-rows: 100%;
      align-items: center;
      justify-content: center;
      grid-gap: 15px;

      > div {
        height: 100%;
        display: grid;
        grid-template-rows: 100px 70px;

        .weather-img {
          height: 100%;
          display: flex;
          justify-content: center;
          img {
            width: 100px;
            height: 100px;
          }
        }

        .weather-info {
          > p {
            margin: 3px 0;
            font-size: 14px;
            text-align: center;
          }
        }
      }
    }

    .gif-wrapper {
      display: grid;
      grid-template-columns: auto max-content;
      align-items: center;
      min: {
        width: 0;
        height: 0;
      };
      height: 100%;
      padding-right: .8em;

      > * {
        min: {
          width: 0;
          height: 0;
        }
      }

      .gif-img-wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        cursor: pointer;
      }

      .aqi-pollutant-list {
        font-size: 13px;
        margin: 0;
        padding: 0;
        color: #606266;
        list-style: none;

        > li {
          padding: .3em 1em .3em .8em;
          cursor: pointer;

          &:hover {
            background-color: #f0f9eb;
            color: #67c23a;
          }

          &.selected {
            background-color: #67C23A;
            color: #ffffff;
          }
        }
      }
    }
  }

  .chart-wapper {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 100%;

    .day-chart {
      height: 100%;
    }
  }
}

.primary-pollutant {
  width: 350px;
  color: #000;

  h3 {
    margin: 0  0 5px 0;
    text-align: center;
  }

  .day-avg {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    // border: 1px dashed RGBA(224, 218, 216, .9);

    > p{
      width: 49%;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin: 5px 0;

      span {
        color: #54c9e8;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }
}

.big-gif-overlay {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, .55);
  z-index: 2001;

  > .big-gif-wrapper {
    display: grid;
    grid-template-columns: auto max-content;
    align-items: center;
    min: {
      width: 0;
      height: 0;
    };
    background-color: #ffffff;

    > * {
      min: {
        width: 0;
        height: 0;
      }
    }

    .gif-img-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      min: {
        width: 800px;
        height: 642px;
      }
      height: 100%;
    }
  }

  .aqi-pollutant-list {
    font-size: 16px;
    margin: 0;
    padding: 0 1em 0 0;
    color: #606266;
    list-style: none;

    > li {
      padding: .3em 1em .3em .8em;
      cursor: pointer;

      &:hover {
        background-color: #f0f9eb;
        color: #67c23a;
      }

      &.selected {
        background-color: #67C23A;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/11AirQualityPrediction/index.vue